//@flow
import * as React from 'react';
import './LabelSmall.css';
import type {children, id} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children
};

const LabelSmall = (props: Props) => {
  return (
    <div id={props.id} className={baseClass("LabelSmall", props.addClasses)}>{props.children}</div>
  );
};

export default LabelSmall;